import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { autocomplete } from './components/autocomplete';
import { button } from './components/button';
import { datepicker } from './components/datepicker';
import { inputtext } from './components/inputtext';
import { multiselect } from './components/multiselect';
import { select } from './components/select';
import { textarea } from './components/textarea';

export const CustomPreset = definePreset(Aura, {
  semantic: {
    // https://uicolors.app/generate/65a476
    primary: {
      '50': '#f1f8f2',
      '100': '#ddeedf',
      '200': '#bedcc3',
      '300': '#92c39d',
      '400': '#65a476',
      '500': '#438658',
      '600': '#316a43',
      '700': '#275537',
      '800': '#21442d',
      '900': '#1c3827',
      '950': '#0f1f15',
    },
    // https://uicolors.app/generate/ecc400
    accent: {
      '50': '#ffffe7',
      '100': '#feffc1',
      '200': '#fffc86',
      '300': '#fff241',
      '400': '#ffe30d',
      '500': '#ecc400',
      '600': '#d19b00',
      '700': '#a66f02',
      '800': '#89560a',
      '900': '#74460f',
      '950': '#442504',
    },
  },
  components: {
    autocomplete,
    button,
    datepicker,
    inputtext,
    multiselect,
    select,
    textarea,
  },
});
